import React from "react";
import {connect} from 'react-redux';
import {showDirtyModal} from "../../actions/common/commonActions";
import ModalPopup from"../../components/common/ModalPopup";
import styles from "../../css/common/popup.less";
import {translate} from '../../i18n/translate';

class DirtyModal extends React.Component {
    closeModal = () => {
        this.props.closeModal();
    };

    leave = () => {
        if(this.props.showModal.onLeaveCallBack) {
            this.props.showModal.onLeaveCallBack();
            this.closeModal();
        }
    };

    render() {
        if (!this.props.showModal)
            return null;
        const message = this.props.message ? this.props.message : "_LoseYourChanges";
        const leaveText = this.props.leaveText ? this.props.leaveText : "Leave";
        const stayText = this.props.stayText ? this.props.stayText : "Stay";

        return (
            <ModalPopup
                onClose={this.closeModal}
                message={translate(message)}
                right={{text:translate(stayText), callback:this.closeModal}}
                left={{text:translate(leaveText), callback:this.leave}}/>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        showModal: (state.orderStatus||{}).showModal
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        closeModal: () => {
            dispatch(showDirtyModal(false));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DirtyModal);


// WEBPACK FOOTER //
// ./src/containers/common/DirtyModal.js